import { MonthlyTrueUpCalculationFilterRepresentation } from "./monthly-true-up-calculation-filter-representation-base";
import { MonthlyTrueUpCalculationFilterProperties } from "./monthly-true-up-calculation-filter-properties";

export class ExportMonthlyTrueUpCalculationFilterRepresentation {
    MonthlyTrueUpCalculationFilterRepresentation: MonthlyTrueUpCalculationFilterRepresentation = undefined;
    MonthlyTrueUpCalculationFilterProperties:MonthlyTrueUpCalculationFilterProperties = undefined;
}